import { render, staticRenderFns } from "./BookingsHistory.vue?vue&type=template&id=2f22c946"
import script from "./BookingsHistory.vue?vue&type=script&lang=js"
export * from "./BookingsHistory.vue?vue&type=script&lang=js"
import style0 from "./BookingsHistory.vue?vue&type=style&index=0&id=2f22c946&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f22c946')) {
      api.createRecord('2f22c946', component.options)
    } else {
      api.reload('2f22c946', component.options)
    }
    module.hot.accept("./BookingsHistory.vue?vue&type=template&id=2f22c946", function () {
      api.rerender('2f22c946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/BookingsHistory.vue"
export default component.exports